import { RecursoCurso } from './../../../entity/recurso-curso.model';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from '../../../base/base-step.component';
import { GerenciamentoCurso } from 'app/entity/gerenciamento-curso.model';
import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { cabecalho } from 'app/entity/cabecalho-prestacao-conta.model';
import { Capacitadora } from 'app/entity/capacitadora.model';
 
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'gerenciamento-curso-etapa4',
    templateUrl: './gerenciamento-curso-etapa4.component.html',
})
export class CrudGerenciamentoCursoEtapa4Component extends BaseStepComponent {

    @Input() cabecalhoSomatorio: cabecalho[];

    @Input() listaResumo: any[] = [];
    @Input() listaRelatores: any[];
    @Input() listaCapacitadora: SelectItem[] = [];
    @Input() listaAbrangencia: SelectItem[] = [];
    @Input() listaModalidade: SelectItem[] = [];
    @Input() listaTipoAtividade: SelectItem[] = [];
    @Input() listaAreaTematica: SelectItem[] = [];
    @Input() listaPublicoAlvo: SelectItem[] = [];
    @Input() listaCriterioAvaliacao: SelectItem[] = [];
    @Input() listaDiasSemana: any[] = [];
    @Input() listaPais: SelectItem[] = [];
    @Input() listaMunicipios: SelectItem[] = [];
    @Input() listaUf: SelectItem[] = [];
    @Input() listaInstrutores: any[] = [];
    @Input() listaTurma: any[] = [];
    @Input() listaConteudo: any[] = [];
    @Input() listaBibliografia: any[] = [];

    @Input() uploadedFiles: any[] = [];
    @Input() storagedListFiles: any[];
    @Output() uploadedFilesChange = new EventEmitter<any>();
    uploadedFilesTemp: any[] = [];

    displayInstrutorModal = false;
    modal_obj: any = null;
    displayConteudoModal = false;
    @Input() capacitadora: any;
    @Input() listaPntCFC: any[];
    @Input() listaPntCRC: any[];
    @Input() etapa: any;
    @Input() id: number;
    @Input() codigo: string;
    controlador = false;

    @Input() listaCursos: SelectItem[] = []
    @Input() listaFormacaoAcademico: any[] = [];
    @Input() listaFormacaoInstrutor: any[] = [];
    @Input() uploadedFilesInstrutor: any[] = [];
    @Input() recurso_curso: RecursoCurso[] = [];
    @Input() recurso: RecursoFiltro;
    instrutor: any;
    gerenciamentoCurso: GerenciamentoCurso = new GerenciamentoCurso;

    @Output() cabecalhoSomatorioChange: EventEmitter<any> = new EventEmitter<any>();

    init() {
        this.service.ListarInstrutores('instrutor').subscribe(data => {
            this.listaInstrutores = data;
        });
        if (this.id !== undefined) {
            this.service.Obter('gerenciamentoCurso/recursoList', this.id).subscribe(item => {
                this.recurso_curso = item;
            });
            this.recurso.IdModel = this.id;
            this.recurso.CursoDto = this.finalizaCurso();
        }
    }

    emitCabecalho() {
        this.cabecalhoSomatorioChange.emit(this.cabecalhoSomatorio);
    }

    showDialog(obj, modal) {

        this.uploadedFilesInstrutor = [];
        if (modal === 1) {
            this.displayInstrutorModal = true;
            this.modal_obj = obj;
            this.instrutor = this.listaInstrutores.find(x => x.id === this.modal_obj);
            let anexos = this.instrutor.anexo_instrutor;
            anexos == !null ? anexos.forEach(x => {
                this.uploadedFilesInstrutor.push(x);
            }) : undefined;

            this.listaFormacaoInstrutor = this.instrutor.formacao_academica_instrutor;
        }

        if (modal === 2) {
            this.displayConteudoModal = true;
            this.modal_obj = obj;
        }
    }
    finalizaCurso(): GerenciamentoCurso {
        // curso
        this.gerenciamentoCurso.id = this.cadastro.get('etapa1.curso.id').value;
        this.gerenciamentoCurso.titulo_original = this.cadastro.get('etapa1.curso.titulo_original').value;
        this.gerenciamentoCurso.titulo_traduzido = this.cadastro.get('etapa1.curso.titulo_traduzido').value;
        this.gerenciamentoCurso.carga_horaria = this.cadastro.get('etapa1.curso.carga_horaria').value;
        this.gerenciamentoCurso.frequencia_minima = this.cadastro.get('etapa1.curso.frequencia_minima').value;
        this.gerenciamentoCurso.id_abrangencia = this.cadastro.get('etapa1.curso.id_abrangencia').value;
        this.gerenciamentoCurso.id_modalidade = this.cadastro.get('etapa1.curso.id_modalidade').value;
        this.gerenciamentoCurso.id_tipo_atividade = this.cadastro.get('etapa1.curso.id_tipo_atividade').value;
        this.gerenciamentoCurso.codigo_curso_capacitadora = this.cadastro.get('etapa1.curso.codigo_curso_capacitadora').value;
        // this.gerenciamentoCurso.bibliografia = this.cadastro.get('etapa1.curso.bibliografia').value;
        this.gerenciamentoCurso.id_capacitadora = this.cadastro.get('etapa1.curso.id_capacitadora').value;
        this.gerenciamentoCurso.id_situacao = this.cadastro.get('etapa1.curso.id_situacao').value;
        this.gerenciamentoCurso.codigo = this.cadastro.get('etapa1.curso.codigo').value;
        this.gerenciamentoCurso.observacao = this.cadastro.get('etapa1.observacao.observacao').value;
        this.gerenciamentoCurso.data_cadastro = this.cadastro.get('etapa1.curso.data_cadastro').value;

        // Conteudo
        this.gerenciamentoCurso.conteudo = this.listaConteudo.map(item => {
            item.id_curso = this.gerenciamentoCurso.id;
            item.curso = null;
            return item;
        });

        // Anexo
        this.gerenciamentoCurso.anexo_curso = [];
        this.uploadedFiles.forEach(item => {
            this.gerenciamentoCurso.anexo_curso.push(item);
        });

        // Turma
        this.gerenciamentoCurso.turma = this.listaTurma.map(item => {
            item.id_curso = this.gerenciamentoCurso.id;
            item.curso = null;
            // tslint:disable-next-line: no-shadowed-variable
            item.turma_dia_semana = item.turma_dia_semana.map(item => {
                item.id = null;
                item.dia_semana = null;
                return item;
            });
            return item;
        });
        // Instrutor

        let gerenciamentoCurso = this.cadastro.get('etapa3.curso_instrutor.list').value;
        if (gerenciamentoCurso || gerenciamentoCurso != null) {

            this.gerenciamentoCurso.curso_instrutor = gerenciamentoCurso.map(item => {
                const valor = { id_instrutor: item, id_curso: this.gerenciamentoCurso.id };
                return valor;
            });
        }
        // urso-Criteiro Avaliação
        // tslint:disable-next-line: max-line-length
        let gerenciamentoCursoCriterio = this.cadastro.get('etapa1.curso.curso_criterio_avaliacao.list').value;

        if (gerenciamentoCursoCriterio || gerenciamentoCursoCriterio != null) {
            this.gerenciamentoCurso.curso_criterio_avaliacao = gerenciamentoCursoCriterio.map(item => {
                const valor = { id_criterio_avaliacao: item, id_curso: this.gerenciamentoCurso.id };
                return valor;
            });
        }

        // Curso-Publico Alvo
        let gerenciamentoCursoPublicoAlvo = this.cadastro.get('etapa1.curso.curso_publico_alvo.list').value;
        if (gerenciamentoCursoPublicoAlvo || gerenciamentoCursoPublicoAlvo != null) {
            this.gerenciamentoCurso.curso_publico_alvo = gerenciamentoCursoPublicoAlvo.map(item => {
                const valor = { id_publico_alvo: item, id_curso: this.gerenciamentoCurso.id };
                return valor;
            });
        }

        // Curso-Area Tematica
        let gerenciamentoCursoAreaTematica = this.cadastro.get('etapa1.curso.curso_area_tematica.list').value
        if (gerenciamentoCursoAreaTematica || gerenciamentoCursoAreaTematica != null) {
            this.gerenciamentoCurso.curso_area_tematica = gerenciamentoCursoAreaTematica.map(item => {
                const valor = { id_area_tematica: item, id_curso: this.gerenciamentoCurso.id };
                return valor;
            });
        }
        if (this.acao === 'cadastrar') {
            this.gerenciamentoCurso.id_situacao = 16;
        }

        // Bibliografia Curso
        this.gerenciamentoCurso.bibliografia_curso = this.listaBibliografia.map(item => {
            item.id_curso = this.gerenciamentoCurso.id;
            return item;
        });

        return this.gerenciamentoCurso;
    }

    replicarCurso() {
        const cursoReplica: GerenciamentoCurso = this.finalizaCurso();
        
        this.service.definirCursoReplicado(cursoReplica);

        this.service.definirExibirAvisoReplica(true);
        
        this.navegarParaCadastro();
    }
    
    navegarParaCadastro() {
        this.router.navigate(
            ['atividades', 'gerenciamento-curso', 'cadastrar'],
            { queryParams: { replicado: true } }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-curso/crud/etapas/gerenciamento-curso-etapa4.component.ts